import { render, staticRenderFns } from "./ThanksIcon.vue?vue&type=template&id=2bb0f28e&"
import script from "./ThanksIcon.vue?vue&type=script&lang=js&"
export * from "./ThanksIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports